import {
  deletePermissionAssignment,
  postPermissionAssignment
} from 'actions/api/admin'

export const createPermissionAssignment = async (payload) => {
  const req = await postPermissionAssignment(payload)
  return { type: 'CREATE_PERMISSION_ASSIGNMENT_SUCCESS', data: req.permission }
}

export const removePermissionAssignment = async (payload) => {
  const req = await deletePermissionAssignment(payload)
  return { type: 'REMOVE_PERMISSION_ASSIGNMENT_SUCCESS', data: req.permission }
}
